<template>
  <div style="position:relative;">
    <div  class="form">
        <input type="search"  v-on:keyup.enter="onEnter" @input="onChange" :placeholder="placeHolder" class="search-field" v-model="search"/>
        <button class="search-button" @click="showScore(search)">
          <img src="../assets/icons/search.png">
        </button>
      </div>
    <div class="dropDown" style="margin-left: 0.6em; width: calc(100% - 2.6em);">
          <ul
          v-show="isOpen && results.length>0"
            class="autocomplete-results"
          >
            <li
              v-for="(result, i) in results"
              :key="i"
              @click="setResult(result)"
              class="autocomplete-result"
            >
               {{result}}
              
            </li>
          </ul>
        </div>
  </div>
</template>

<script>
import ValidIcon from '@/components/ValidIcon.vue';
import Validate from '@/mixins/validate.js'
export default {
    name: "textInput",
    mixins:[Validate],
    components:{ValidIcon},
    props: {
        items: {
            type: Array,
            required: false,
            default: () => [],
        },
        field: {
            type: String,
            required: false,
            default: () => "",
        },
        placeHolder: {
          type: String,
            required: false,
            default: () => "",
        },
        showAdd: {
            type: Boolean,
            required: false,
            default: () => false,
        },
        doAdd: {
            type: Function,
            required: false,
            default: () => null,
        },
        validation: {
            type: Array,
            required: false,
            default: () => [],
        },

    },
    data() {
        return {
            search: "",
            results: [],
            isOpen: false,
           
           
        };
    },
    mounted() {
        document.addEventListener("click", this.handleClickOutside);
    },
    destroyed() {
        document.removeEventListener("click", this.handleClickOutside);
    },
    computed:{
      
    },
    methods: {
      onEnter: function() {
       this.showScore()
    },
      showScore(){
        
          this.search=this.fullCase(this.search)
           this.$emit("showScore",this.search)
            this.isOpen = false;
            this.results =[]
      },
        clearField(){
          this.search=""
           this.isOpen = false;
        },
        filterResults() {
            let result = this.items.filter(item => item.toLowerCase().indexOf(this.search.toLowerCase()) > -1);
             this.results = [...new Set(result)];
             if(this.search.length>1){
              this.$emit('results',this.results)
             }else{
              this.$emit('results',[])
             }
             
        },
        setResult(result) {
            this.search = result;
           this.showScore()
        },
        onChange() {
          
          this.$emit("showScore",null)
            this.filterResults();
            this.isOpen = true;
            this.updateVal()
        },
        handleClickOutside(event) {
            let self = this;
            if (!this.$el.contains(event.target)) {
                self.isOpen = false;
            }
        },
        fullCase(lcText){
          let FC=""
          for (var i in this.items){
            if(lcText.toLowerCase()==this.items[i].toLowerCase()){
              FC=this.items[i]
            }
          }
          return FC
        }
    },
    watch:{
     items(val){
      
      this.results=this.items
       
        this.filterResults()
        
     }
    }
   
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "@/css/colors.scss";
  .textField{
    display:flex;
    padding:0px 10px;
    min-width:100px;
   
  }
  input{
    height:2em;
    border-left:none;
    border-right:none;
    border-top:none;
    min-width:120px;
    font-size:1em;

  }
  
  
 .autocomplete {
    position: relative;
  }

  .autocomplete-results {
    padding: 0;
    margin: 0;
    border: 1px solid #eeeeee;
    height: 200px;
    min-height: 1em;
    max-height: 10em;    
    overflow: auto;
  }

  .autocomplete-result {
    list-style: none;
    text-align: left;
    padding: 4px 2px;
    cursor: pointer;
  }

  .autocomplete-result:hover {
    background-color: $dropdown-selectBG;
    color: $dropdown-select;
  }
  .dropDown{
  position:absolute; 
  background-color: #fffd;
    width: 135px;
    margin-left: 5px;

  
  }
 .form {
  display: flex;
  flex-direction: row;
  height:inherit;
  font-size:inherit;
}
.search-field {
  width: 100%;
  padding: 10px 35px 10px 15px;
  height:inherit;
  border: none;
  border-radius: 100px;
  font-size:inherit;
  outline: none;
}

.search-button {
  background: transparent;
  border: none;
  outline: none;
  margin-left: -33px;
}

.search-button img {
  width: 20px;
  height: 20px;
  object-fit: cover;
}

#Search::-webkit-search-cancel-button{
    position:relative;
    right:20px;    
}
</style>
